import { SUBMIT_PARAM } from 'site-modules/data-privacy-request/constants/constants';

const buildUrl = (routerLocation, queryParams) => {
  const serializedParams = queryParams.toString();
  return `${routerLocation.pathname}${serializedParams.length ? '?' : ''}${serializedParams}`;
};

export const getSubmitQueryParam = routerLocation => {
  const params = new URLSearchParams(routerLocation.search);
  return params.get(SUBMIT_PARAM);
};

export const removeSubmitQueryParam = routerLocation => {
  const params = new URLSearchParams(routerLocation.search);
  params.delete(SUBMIT_PARAM);
  window.history.pushState({}, '', buildUrl(routerLocation, params));
};

export const appendSubmitQueryParam = routerLocation => {
  const params = new URLSearchParams(routerLocation.search);
  params.append(SUBMIT_PARAM, 'true');
  window.history.pushState({}, '', buildUrl(routerLocation, params));
};
